import React, { useState, useEffect } from "react";
import { FormControl } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
    ShippingAgentAutoComplete,
    ShippingServiceAutoComplete,
} from "../AutoComplete/AutoCompletes";
import { Option } from "../../Types/CommonTypes";

interface Props {
    shippingAgentCode?: string | null;
    shippingServiceCode?: string | null;
    onChange: (agent: string, service: string) => void;
    disabled?: boolean;
    infoTextAgent?: string;
    infoTextService?: string;
    isLoading: boolean;
}

const ShippingAgentServiceSelect: React.FC<Props> = ({
    shippingAgentCode,
    shippingServiceCode,
    onChange,
    disabled = false,
    infoTextAgent,
    infoTextService,
    isLoading
}) => {
    const { t } = useTranslation();

    const [agent, setAgent] = useState(shippingAgentCode || "");
    const [service, setService] = useState(shippingServiceCode || "");

    useEffect(() => {

        setAgent(shippingAgentCode || "");
    }, [shippingAgentCode]);
    useEffect(() => {

        setService(shippingServiceCode || "");
    }, [shippingServiceCode]);

    const handleAgentChange = (selected: Option | null) => {
        const code = selected?.value || "";

        setAgent(code);
        setService("");
        onChange(code, "");
    };

    const handleServiceChange = (selected: Option | null) => {
        const code = selected?.value || "";

        setService(code);
        onChange(agent, code);
    };

    return (
        <>
            <FormControl fullWidth margin="normal">
                <ShippingAgentAutoComplete
                    key={agent || null}
                    valueId={agent || null}
                    onChange={handleAgentChange}
                    disabled={disabled}
                    infoText={infoTextAgent}
                    load={true}
                />
            </FormControl>
            <FormControl fullWidth margin="normal">
                <ShippingServiceAutoComplete
                    key={service || null}
                    shippingAgentCode={agent || null}
                    valueId={service || null}
                    onChange={handleServiceChange}
                    disabled={disabled}
                    infoText={infoTextService}
                    load={!!agent}
                />
            </FormControl>
        </>
    );
};

export default ShippingAgentServiceSelect;
